import { render, staticRenderFns } from "./yearsCelebra.vue?vue&type=template&id=7b75d3c5&scoped=true&"
import script from "./yearsCelebra.vue?vue&type=script&lang=js&"
export * from "./yearsCelebra.vue?vue&type=script&lang=js&"
import style0 from "./yearsCelebra.vue?vue&type=style&index=0&id=7b75d3c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b75d3c5",
  null
  
)

export default component.exports